import React from 'react';
import { Card, CardContent } from './ui/card';
import { Star, Building2 } from 'lucide-react';
import { testimonials, stats } from '../mock/data';

const ClientsSection = () => {
  const sectors = [
    { name: 'Operador Logístico', icon: '🚛' },
    { name: 'Área Saúde', icon: '🏥' },
    { name: 'Indústria', icon: '🏭' },
    { name: 'Comércio', icon: '🛒' },
    { name: 'Serviços', icon: '💼' },
    { name: 'Educação', icon: '🎓' },
    { name: 'Financeiro', icon: '💰' }
  ];

  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-12 md:mb-16 animate-on-scroll opacity-0 translate-y-8 transition-all duration-700">
          <span className="text-sm font-semibold tracking-wider uppercase text-[#0079be] mb-2 block">
            CONFIANÇA COMPROVADA
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Empresas que Confiam na TMC
          </h2>
          <p className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto">
            Mais de 15 anos de experiência atendendo as maiores corporações em setores críticos.
          </p>
        </div>

        {/* Sectors */}
        <div className="mb-16 animate-on-scroll opacity-0 translate-y-8 transition-all duration-700">
          <h3 className="text-xl font-bold text-gray-900 text-center mb-8">Setores Atendidos</h3>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-7 gap-4">
            {sectors.map((sector, index) => (
              <div
                key={index}
                className="bg-white rounded-xl p-6 text-center hover:shadow-lg transition-all duration-300 hover:-translate-y-1 cursor-pointer group"
              >
                <div className="text-4xl mb-2 group-hover:scale-110 transition-transform duration-300">
                  {sector.icon}
                </div>
                <p className="text-sm font-semibold text-gray-700">{sector.name}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Testimonials */}
        <div className="mb-16">
          <h3 className="text-2xl md:text-3xl font-bold text-gray-900 text-center mb-8 animate-on-scroll opacity-0 translate-y-8 transition-all duration-700">
            O Que Nossos Clientes Dizem
          </h3>
          <div className="grid md:grid-cols-3 gap-8">
            {testimonials.map((testimonial, index) => (
              <Card
                key={index}
                className="animate-on-scroll opacity-0 translate-y-8 transition-all duration-700 hover:shadow-xl group"
                style={{ transitionDelay: `${index * 100}ms` }}
              >
                <CardContent className="p-8">
                  {/* Stars */}
                  <div className="flex space-x-1 mb-4">
                    {[...Array(5)].map((_, i) => (
                      <Star key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" />
                    ))}
                  </div>

                  {/* Quote */}
                  <p className="text-gray-600 italic mb-6 leading-relaxed">
                    "{testimonial.quote}"
                  </p>

                  {/* Author */}
                  <div className="flex items-start space-x-3 pt-4 border-t border-gray-200">
                    <div className="w-12 h-12 rounded-full bg-[#0079be] flex items-center justify-center flex-shrink-0">
                      <span className="text-white font-bold text-lg">
                        {testimonial.author.charAt(0)}
                      </span>
                    </div>
                    <div>
                      <p className="font-bold text-gray-900">{testimonial.author}</p>
                      <p className="text-sm text-gray-600">{testimonial.position}</p>
                      <p className="text-sm text-[#0079be] font-semibold">{testimonial.company}</p>
                    </div>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>

        {/* Stats */}
        <div className="animate-on-scroll opacity-0 translate-y-8 transition-all duration-700">
          <div className="bg-gradient-to-br from-[#0079be] to-[#005a8c] rounded-3xl p-8 md:p-12 shadow-2xl">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
              {stats.map((stat, index) => (
                <div key={index} className="text-center">
                  <div className="text-4xl md:text-5xl font-bold text-white mb-2">
                    {stat.value}
                  </div>
                  <div className="text-white/90 font-medium">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ClientsSection;